"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventName = void 0;
var EventName;
(function (EventName) {
    EventName["LEGACY_EVENT"] = "legacyEvent";
    EventName["EXPERIMENT_EVENT"] = "experimentEvent";
    EventName["FILTER_INTERACTION"] = "filterInteraction";
})(EventName = exports.EventName || (exports.EventName = {}));
